import React, { setGlobal } from 'reactn';
import styled from 'styled-components';
import { withApollo } from 'react-apollo';
import moment from 'moment';
import Button from '../../common/components/Button';
import TimesheetGridRowComment from './TimesheetGridRowComment';
import TimesheetGridRowHourContainer from './TimesheetGridRowHourContainer';
import { GET_USER_TIMESHEET } from '../queries';
import Popconfirm from '../../common/components/Popconfirm';
import { REMOVE_TIMESHEET_LINEITEM } from '../mutations';
import { getWeekDays } from '../../common';
import { Badge } from '@mantine/core';
import AssignedResourceIndicator from './AssignedResourceIndicator';

const Row = styled.tr`
  &:hover {
    background-color: #f9f9f9;
  }
`;

const Col = styled.td`
  padding: 1em;
  width: ${props => (props.width ? props.width : 'initial')};
  text-align: ${props => (props.align ? props.align : 'initial')};
`;

const setLoading = (loading, delay) => {
  if (delay) {
    setTimeout(() => {
      setGlobal({ loading });
    }, delay);
  } else {
    setGlobal({ loading });
  }
};

class TimesheetGridRow extends React.Component {
  state = {
    removeLoading: false,
  };

  handleRemoveRow = () => {
    setLoading(true);
    this.setState({ removeLoading: true });
    setTimeout(() => {
      this.props.client
        .mutate({
          mutation: REMOVE_TIMESHEET_LINEITEM,
          awaitRefetchQueries: true,
          refetchQueries: [
            {
              query: GET_USER_TIMESHEET,
              variables: {
                endDate: this.props.endDate,
                user: this.props.user._id,
              },
            },
          ],
          variables: {
            timesheetId: this.props.timesheetId,
            lineItemIndex: this.props.lineItemIndex,
            user: this.props.user._id,
          },
        })
        // componented will be unmounted so no need to call setState
        .then(() => setLoading(false));
    }, 500);
  };

  render() {
    const { timesheetId, lineItem, isLocked, endDate, className, showHoursUsedOnTs, weekEndDay } = this.props;
    const { project, deliverable } = lineItem;
    const newTaskRequiredFields = {
      timesheetId,
      projectId: project._id,
      deliverableId: deliverable._id,
    };
    const trackAgainstTimeOff = deliverable.trackAgainstTimeOff;

    const days = getWeekDays(weekEndDay);

    return (
      <Row className={className}>
        <Col>
          <div className="flex flex-row gap-2">
            <div>- {deliverable.deliverableName}</div>
            {trackAgainstTimeOff && (
              <Badge variant="gradient" gradient={{ from: 'orange', to: 'red' }}>
                {trackAgainstTimeOff}
              </Badge>
            )}
            {!isLocked && showHoursUsedOnTs && deliverable.hasAssignedResources && (
              <AssignedResourceIndicator user={this.props.user} deliverable={deliverable} />
            )}
          </div>
        </Col>
        <Col className="md:table-cell">
          <TimesheetGridRowComment isLocked={isLocked} lineItem={lineItem} user={this.props.user} weekEndDay={weekEndDay} />
        </Col>
        {days.map((day, index) => {
          const date = moment(endDate)
            .subtract(6 - index, 'days')
            .format('YYYYMMDD');
          const disabled = false; //moment(date).isBefore('2023-09-18', 'day');

          return (
            <Col key={day} align="center">
              <TimesheetGridRowHourContainer
                isRemoving={this.state.removeLoading}
                isLocked={isLocked}
                disabled={disabled}
                user={this.props.user}
                task={lineItem[`${day}Task`]}
                endDate={endDate}
                deliverable={deliverable}
                newTaskRequiredFields={{
                  ...newTaskRequiredFields,
                  date,
                }}
              />
            </Col>
          );
        })}
        {!this.props.isLocked && (
          <Col align="center">
            <Popconfirm
              placement="topLeft"
              title="Are you sure you want to delete this task?"
              onConfirm={this.handleRemoveRow}
              okText="Yes"
              cancelText="No"
            >
              <Button
                loading={this.state.removeLoading}
                disabled={this.global.loading}
                shape="circle"
                icon="close"
                type="danger"
                ghost
              />
            </Popconfirm>
          </Col>
        )}
      </Row>
    );
  }
}

export default withApollo(TimesheetGridRow);
